import { Model, Attr, HasOne } from 'spraypaint';
import ApplicationRecord from '../ApplicationRecord';
import { Customer } from '../';

@Model()
export default class User extends ApplicationRecord {
  static jsonapiType = 'users';

  static async register({
    email,
    password,
    title,
    firstName,
    lastName,
    phoneNumber,
    business,
  }: {
    email: string;
    password: string;
    title: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    business: string;
  }) {
    const user = new User({ email, password });
    user.title = title;
    user.firstName = firstName;
    user.lastName = lastName;
    user.phoneNumber = phoneNumber;
    user.business = business;
    await user.save();
    return user;
  }

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
        sortable: false,
      },
      {
        text: 'Email address',
        value: 'email',
      },
      {
        text: 'Name',
        value: 'firstName',
      },
    ];
  }

  static scopeFactory() {
    return User.includes([]);
  }

  @Attr() email: string;
  @Attr() roles: string[];
  @Attr() title: string;
  @Attr() firstName: string;
  @Attr() lastName: string;
  @Attr() phoneNumber: string;
  @Attr() business: string;

  @HasOne() customer: Customer;

  // write only
  @Attr() password: string;
  @Attr() currentPassword: string;

  get fullName() {
    const first = this.customer.firstName || '';
    const last = this.customer.lastName || '';
    return `${first} ${last}`;
  }

  // not used - fix me!
  changePassword(currentPassword: string, newPassword: string) {
    const user = new User({ id: this.id });
    user.isPersisted = true;
    user.password = newPassword;
    user.currentPassword = currentPassword;
    return user.save();
  }
}
